module.exports = __webpack_public_path__ + "static/media/coreimg1.04533d87.png";